import type {
	ConstructionDocument as ApiConstructionDocument,
	DocumentCountsByCategory,
	ListDocumentsResponse,
} from "@/adapters/api";
import type {
	ConstructionDocument,
	DocumentCounts,
	DocumentsPage,
} from "../types.ts";
import { DOCUMENT_CATEGORIES, isDocumentCategory } from "./categories.ts";

export function toDocument(
	document: ApiConstructionDocument,
): ConstructionDocument {
	return {
		id: document.id,
		title: document.title,
		fileName: document.file_name,
		category: isDocumentCategory(document.category)
			? document.category
			: "other",
		contentType: document.content_type,
		sizeBytes: document.size_bytes,
		clientVisible: !!document.client_visible,
		uploadedBy: {
			id: document.uploaded_by?.id ?? "",
			name: document.uploaded_by?.name ?? "",
		},
		createdAt: document.created_at,
		updatedAt: document.updated_at,
	};
}

export function toDocumentCounts(
	counts: DocumentCountsByCategory,
): DocumentCounts {
	return Object.fromEntries(
		DOCUMENT_CATEGORIES.map((category) => [category, counts[category] ?? 0]),
	) as DocumentCounts;
}

export function totalDocuments(counts: DocumentCounts): number {
	return DOCUMENT_CATEGORIES.reduce(
		(sum, category) => sum + counts[category],
		0,
	);
}

export function toDocumentsPage(
	response: ListDocumentsResponse,
): DocumentsPage {
	return {
		count: response.count,
		items: response.items.map(toDocument),
		countsByCategory: toDocumentCounts(response.counts_by_category),
	};
}
